(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('seeking-gender', {
            parent: 'entity',
            url: '/seeking-gender',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'publicGatewayApp.seekingGender.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/seeking-gender/seeking-genders.html',
                    controller: 'SeekingGenderController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('seekingGender');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('seeking-gender-detail', {
            parent: 'entity',
            url: '/seeking-gender/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'publicGatewayApp.seekingGender.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/seeking-gender/seeking-gender-detail.html',
                    controller: 'SeekingGenderDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('seekingGender');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'SeekingGender', function($stateParams, SeekingGender) {
                    return SeekingGender.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'seeking-gender',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('seeking-gender-detail.edit', {
            parent: 'seeking-gender-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/seeking-gender/seeking-gender-dialog.html',
                    controller: 'SeekingGenderDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SeekingGender', function(SeekingGender) {
                            return SeekingGender.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('seeking-gender.new', {
            parent: 'seeking-gender',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/seeking-gender/seeking-gender-dialog.html',
                    controller: 'SeekingGenderDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                shortName: null,
                                title: null,
                                sortOrder: null,
                                enable: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('seeking-gender', null, { reload: 'seeking-gender' });
                }, function() {
                    $state.go('seeking-gender');
                });
            }]
        })
        .state('seeking-gender.edit', {
            parent: 'seeking-gender',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/seeking-gender/seeking-gender-dialog.html',
                    controller: 'SeekingGenderDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SeekingGender', function(SeekingGender) {
                            return SeekingGender.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('seeking-gender', null, { reload: 'seeking-gender' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('seeking-gender.delete', {
            parent: 'seeking-gender',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/seeking-gender/seeking-gender-delete-dialog.html',
                    controller: 'SeekingGenderDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SeekingGender', function(SeekingGender) {
                            return SeekingGender.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('seeking-gender', null, { reload: 'seeking-gender' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
